import { IQuestion } from "services/KnowfullyAdminClient";

export const IMPORTED_QUESTION_ID_PREFIX = "imported_";

export const ALPHABET = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";

export const isImportedQuestion = (question: IQuestion): boolean =>
  !question.id || question.id.startsWith(IMPORTED_QUESTION_ID_PREFIX);

export const assignImportedIds = (questions: IQuestion[]): IQuestion[] =>
  questions.map((q, index) => ({
    ...q,
    id: `${IMPORTED_QUESTION_ID_PREFIX}${index}`,
  }));

export const computeCorrectAnswersLetters = (question: IQuestion): string => {
  if (question.correctAnswersLetters) {
    return question.correctAnswersLetters;
  }

  const answers = question.evaluationQuestionAnswers ?? [];
  const sortedAnswers = [...answers].sort(
    (a, b) => (a.sequence ?? 0) - (b.sequence ?? 0)
  );

  const letters: string[] = [];
  sortedAnswers.forEach((answer, index) => {
    if (answer.isAnswer) {
      let letter = "";
      if (index >= ALPHABET.length) {
        letter += ALPHABET[Math.floor(index / ALPHABET.length) - 1];
      }
      letter += ALPHABET[index % ALPHABET.length];
      letters.push(letter);
    }
  });

  return letters.join(",");
};
